const indices = [
  { icon: 'ri-fire-line', label: '本周热播', count: '24部', desc: '实时热度榜单追踪' },
  { icon: 'ri-calendar-check-line', label: '即将上线', count: '18部', desc: '定档新剧抢先预览' },
  { icon: 'ri-star-line', label: '高分推荐', count: '36部', desc: '豆瓣8分以上精选' },
  { icon: 'ri-tv-line', label: '国产剧场', count: '52部', desc: '国产好剧一网打尽' },
  { icon: 'ri-global-line', label: '海外精选', count: '41部', desc: '韩美日剧精选' },
  { icon: 'ri-movie-line', label: '院线追踪', count: '15部', desc: '最新电影上映动态' },
  { icon: 'ri-live-line', label: '综艺专区', count: '28档', desc: '热门综艺在线同步' },
  { icon: 'ri-compass-3-line', label: '冷门佳片', count: '63部', desc: '挖掘被埋没的好片' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大专题入口，帮你精准找到想看的内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indices.map((item, idx) => (
            <div
              key={idx}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                {item.label}
              </h3>
              <p className="text-xl md:text-2xl font-heading font-bold text-primary-600 mb-1">
                {item.count}
              </p>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}